import type { ChangeFlightPage } from '@/app/common/starTrack/events/utils/starTrack.types.ts';

export const CHANGE_FLIGHT_LINK_CLICKED = 'CHANGE_FLIGHT_LINK_CLICKED';
export const CHANGE_FLIGHT_LINK_CLICKED_VERSION = '1.1';

export type ChangeFlightLinkClickedPayload = {
  searchId: string;
  productDetailKey: string;
  page: ChangeFlightPage;
};

export type ChangeFlightLinkClickedParams = {
  searchId: string;
  productDetailKey: string;
  page: ChangeFlightPage;
};

export const createChangeFlightLinkClickedPayload = (
  params: ChangeFlightLinkClickedParams
): ChangeFlightLinkClickedPayload => {
  const { searchId, productDetailKey, page } = params;

  return {
    searchId,
    productDetailKey,
    page,
  };
};
